export default {
  methods: {
    downloadCvMix(format, hideModalShare = () => {
    }) {
      // NProgress.start();
      this.$store.commit("cvDownload");
      this.$http({
        method: "post",
        url: '/api/cv/download',
        data: {
          id: this.$store.getters.cvDownloadId,
          format
        },
        responseType: "json"
      }).then(res => {
        // NProgress.done();
        hideModalShare();
        if (!res.data.is_load) {
          this.$store.commit('modalLoader', true);
          var $this = this;
          setTimeout(
            function () {
              $this.downloadCvMix(format, hideModalShare());
            }, 1000);
        } else if (res.data.has_tariff) {
          this.$store.commit('modalLoader', false);
          this.downloadFile(format, res.data.url, res.data.filename);
        } else {
          this.$store.commit('modalLoader', false);
          this.$store.commit('downloadFormat',format);
          this.$store.commit('modalBuy', res.data.tariff_name);
        }
      });
    },
    activateUserStatusBasic(format) {
      this.$http({
        method: "post",
        url: '/api/activate-basic-status',
        responseType: "json"
      }).then(res => {
        this.downloadCvMix(format);
        this.$store.commit("user", res.data.user);
      });
    },
    saveTemplateImgAndPdf(cv_id) {
      this.$http({
        method: "post",
        url: '/api/cv/save/files',
        data: {
          cv_id
        },
        responseType: "json"
      }).then(res => {
      });
    },
    downloadFile(format, url, filename) {
      var a = document.createElement("a");
      a.style = "display: none";
      a.href = url;
      a.setAttribute(
        "download",
        `${filename}.${format}`
      );
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};



// WEBPACK FOOTER //
// ./resources/js/mixins/cvDownload.js